import { Box } from "@mui/material";
import * as React from "react";
import { Outlet } from "react-router";
import LoadingIcon from "../common/components/LoadingIcon";
import useGeneralHook from "../common/hook/useGeneralHook";
import { loadNRETypeData } from "../modules/nreType/nreTypeReducer";
import DefaultAside from "./DefaultAside";
import DefaultBreadcrumb from "./DefaultBreadcrumbs";
import Header from "./Header";
import { IRouteObject } from "./utils";
import Cookies from "js-cookie";
import { MODE_THEME } from "../common/constants";
import { setModeTheme } from "../common/reducer/commonReducer";

interface Props {
  listRoutes: IRouteObject[];
}

const DefaultLayout: React.FunctionComponent<Props> = (props: Props) => {
  const { listRoutes } = props;
  const { dispatch } = useGeneralHook();

  const mode = "dark";
  React.useEffect(() => {
    Cookies.set(MODE_THEME, mode);
    dispatch(setModeTheme(mode));
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(loadNRETypeData());
  }, [dispatch]);

  return (
    <Box
      display="flex"
      minHeight="100vh"
      style={{ height: "100%", width: "100%" }}
      bgcolor={"background.blue"}
    >
      {/* <DefaultAside listRouter={listRoutes} /> */}
      <Box
        paddingBottom={0}
        minHeight={"100%"}
        flexGrow={1}
        width="70vw"
        flex={1}
        position={"relative"}
        display="flex"
        flexDirection="column"
        paddingTop={7}
        paddingX={2}
      >
        {/* <Header openAside={true}  /> */}
        <DefaultBreadcrumb listRouter={listRoutes} />
        <React.Suspense fallback={<LoadingIcon />}>
          <Outlet />
        </React.Suspense>
      </Box>
    </Box>
  );
};

export default DefaultLayout;
